import React from 'react';
import {
  core_apimessages_Address as Address,
} from '../../../schemas/rql';
import AddressSummary from '../../address_summary';

interface Props {
  loading: boolean;
  address: Address;
}

export default function ShippingAddress({ loading, address }: Props) {
  if (loading) {
    return (
      <p className="formatted-address formatted-address--placeholder">
        <span className="formatted-address__highlight" />
      </p>
    );
  }

  return <AddressSummary address={address} />;
}
